<div class="content-with-stepper-and-title">
  <main>
    <h1 id="generalTitle" class="sub-title offset-inline selfie-title" [innerHtml]="copyService.copies.pay_day_form_tc_title"></h1>
    <div class="content-checkbox">
      <voxel-radio-button-group id="payDayList">
        <voxel-radio-button radioName="listpay" *ngFor="let pay of listPayDay" [id]="pay.elementId" [checked]="pay.checked" (radioButtonChange)="onRadioChange($event, 0)" [value]="pay">
          {{pay.label}}
        </voxel-radio-button>
      </voxel-radio-button-group>
    </div>
    <h1 id="generalTitle" class="sub-title offset-inline selfie-title d-inline-block">
      {{copyService.copies.pay_day_form_tc_franchise}}
      <vcl-additional-info *ngIf="!isGrayZone && multipleProduct" id="vclAdditionInfoLeft" class="info-icon" [text]="copyService.copies.multiple_franchise_credit_card" position="down-left" a11yLabelButton="ciiuCode"></vcl-additional-info>
      <vcl-additional-info *ngIf="!isGrayZone && multipleProduct" id="vclAdditionInfoRight" class="info-icon" [text]="copyService.copies.multiple_franchise_credit_card" position="down-right" a11yLabelButton="ciiuCode"></vcl-additional-info>
    </h1>
    <div class="content-checkbox">
      <voxel-radio-button-group id="productList" *ngIf="isGrayZone || !multipleProduct">
        <voxel-radio-button radioName="listproduct" *ngFor="let products of listProducts" [id]="products.elementId" [checked]="products.checked" (radioButtonChange)="onRadioChange($event, 1)" [value]="products">
          {{products.label}}
        </voxel-radio-button>
      </voxel-radio-button-group>
      <voxel-checkbox-group id="checkBoxGroup" *ngIf="!isGrayZone && multipleProduct">
        <voxel-checkbox class="product-check-box" *ngFor="let product of listProducts" id="productList" [label]="product.label" [disabled]="product.disabled && !product.checked" [checked]="product.checked" name="product" [value]="product" (checkboxChange)="onCheckBoxChange($event, product, 1)">
        </voxel-checkbox>
      </voxel-checkbox-group>
    </div>
  </main>
  <app-controls id="payDayBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_contact_btn" [nextDisabled]="!enableButtonNext" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
</div>
